module.exports = __webpack_public_path__ + "img/instagram.78549a06.png";